/* @flow */
const DEFAULT_HEADER='phoenix-auth-token';
export const API_GET:string='GET';
export const API_POST:string='POST';
export const API_PUT:string='PUT';
export const API_DELETE:string='DELETE';

export type API_METHOD = typeof API_GET | typeof API_POST | typeof API_PUT | typeof API_DELETE

export const callFetch = (method: API_METHOD,url: string,payload?:any | null,authToken?: string,authHeader?:string) => {
    let header=DEFAULT_HEADER;
    
    if (authHeader) {
        header=authHeader;
    }
    
    let headers={};
    if (authToken){
        headers[header]=authToken;
    }
    headers['Content-Type']='application/json';
    
    if (method===API_GET){
        return fetch(url, {
            method: method,
            headers,
            credentials: "same-origin"
        });
    }else {
        return fetch(url, {
            method: method,
            body: JSON.stringify(payload),
            headers,
            credentials: "same-origin"
        });
    }
}


// WEBPACK FOOTER //
// ./src/apiUtils/apiBase.js